<section class="myWallet-section" *ngIf="userObject">
  <div id="snackbar"></div>
  <div class="background">
    <div class="mywallet-head">
      <h1 style="display: inline-block" class="page-title setting-txt">{{"SETTINGS" | translate}}</h1>
      <a class="helpbtn d-none" style="float:right;margin-top:35px;margin-right: auto" href="https://fruture.org/twoFactorInfo.html" target="_blank">{{"Help"| translate}}</a>
      <toaster-container [toasterconfig]="config"></toaster-container>
    </div>
    <div class="settings-content-div">
      <div class="row not-padded">
        <div class="col-lg-6">
          <div class="genral-sett-div">

            <h2 class="sub-title no-left-margin">{{'GENERAL SETTINGS' | translate}}

            </h2>
           



            <div class="genral-sett-div-content">
              <!-- <div class="width93">
                <p class="gnrl-settng-content-txt">
                  Nullam luctus eu risus ac convallis. Donec quis velit id purus porta condimentum sed a dui. Sed justo
                  nulla, facilisis consequat
                  dictum sit amet, bibendum in nulla.
                </p>
              </div> -->
              <hr class="settings-hr" />
              <div class="gnrl-setting-form">
                <div class="row">
                  <!--   <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"> -->
                  <!-- Original: <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"> -->
                  <div class="col-12 settings-form-field">
                    <div class="form-group">
                      <label for="name" class="nn-lbl-sett">{{'Name' | translate}}:</label>
                      <input type="text" class="form-control nn-input-sett" id="name" name="userObject.Name"
                        [(ngModel)]="userObject.Name">

                    </div>
                  </div>
                  <!-- Original: <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"> -->
                  <div class="col-12 settings-form-field">
                    <div class="form-group">
                      <label for="name" class="nn-lbl-sett">{{'Username' | translate}}:</label>
                      <input readonly type="text" class="form-control nn-input-sett" id="username" name="userObject.UserName"
                        [(ngModel)]="userObject.UserName">

                    </div>
                  </div>
                  <!-- Original: <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4"> -->
                  <div class="col-12 settings-form-field">
                    <div class="form-group">
                      <label for="email" class="nn-lbl-sett">{{'Email' | translate}}:</label>
                      <input readonly type="email" class="form-control nn-input-sett" id="email" name="userObject.Email"
                        [(ngModel)]="userObject.Email" value="">
                    </div>
                  </div>

                </div>


                <!-- <div class="row">
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                    <div class="form-group ">
                      <label for="name" class="nn-lbl-sett">Member Type:</label>
                      <input type="text" [(ngModel)]="userObject.memberType" class="form-control nn-input-sett" readonly id="membertype" name="userObject.memberType"
                        >

                    </div>
                  </div>
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                    <div class="form-group">
                      <label for="name" class="nn-lbl-sett">License Code:</label>
                      <input readonly type="text" [(ngModel)]="userObject.licenseCode" class="form-control nn-input-sett" id="code" name="userObject.licenseCode"
                       >

                    </div>
                  </div>
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                    <div class="form-group">
                      <label for="email" class="nn-lbl-sett">License No:</label>
                      <input readonly type="text" [(ngModel)]="userObject.licenseNo" class="form-control nn-input-sett" id="licenseNo" name="userObject.licenseNo"
                        value="">
                    </div>
                  </div>

                </div> -->


                <!-- <div class="row mar-top10">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="form-group">
                      <label for="pass" class="nn-lbl-sett">Eth {{'Address' | translate}}:</label>
                      <p style="font-size: 11px" class="color-blue">
                        ({{'Eth Address must be valid ERC-20 Wallet Address and must not be an exchange address' | translate}})
                      </p>
                      <input type="text" class="form-control nn-input-sett" name="userWalletAddress" [(ngModel)]="userWalletAddress">

                    </div>
                  </div>
                </div> -->

                <div class="row mar-top10">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <p  class="nn-lbl-sett">Account Withdrawal Status:</p>
                    <ul  class="nn-lbl-sett ml-3">
                      <li>Active 1 (Up to $1000 per day)</li>
                      <li>Active 2 ($1,001+ per day)</li>
                      <li>Suspended (Not able to withdraw)</li>
                    </ul>
                  </div>
                </div>

                <div class="btm-btns-div clearfix float-r-inside" *ngIf="changeGeneralBtn">
                  <div class="leftside clearfix">
                    <button class="update-buttons" (click)="updateGeneralSettings()">
                      {{'UPDATE' | translate}}
                    </button>
                  </div>
                  <!-- <div class="leftside clearfix m-left-25">
                                        <button class="cancel-buttons">
                                            cancel
                                        </button>
                                    </div> -->

                </div>

                <div class="clear"></div>
              </div>



            </div>
          </div>

          <div class="update-password">

            <div class="gnrl-setting-form">

              <h2 class="sub-title no-left-margin">{{'UPDATE PASSWORD' | translate}}

              </h2>


              <div class="row mar-top10">
                <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"> -->
                <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group pwd-rel">
                    <label for="pass" class="nn-lbl-sett">{{'Old Password:' | translate}}</label>
                    <input type="password" #currentpassword class="form-control nn-input-sett" ame="pass" name="oldPassword" [(ngModel)]="oldPassword">
                    <span *ngIf="!isShow"  class="toggle-password toggle-settings fa fa-eye-slash" (click)=" showPassword('currentpassword')"></span>
                    <span  *ngIf="isShow"  class="fa fa-eye toggle-password toggle-settings" (click)="hidePassword('currentpassword')"></span>

                  </div>
                </div>

                <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group pwd-rel">
                    <label for="pass" class="nn-lbl-sett">{{'Password' | translate}}:</label>
                    <input type="password" #newpassword class="form-control nn-input-sett" id="pass" name="password" [(ngModel)]="password"
                      name="pass" value="">

                      <span *ngIf="!isNew"  class="toggle-password toggle-settings fa fa-eye-slash" (click)=" showPassword('newpassword')"></span>
                      <span  *ngIf="isNew"  class="fa fa-eye toggle-password toggle-settings" (click)="hidePassword('newpassword')"></span>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group pwd-rel">
                    <label for="cpass" class="nn-lbl-sett">{{'Confirm Password' | translate}}:</label>
                    <input type="password" #confirmpassword class="form-control nn-input-sett" id="cpass" name="cPassword" [(ngModel)]="cPassword"
                      value="">
                      <span *ngIf="!isConfirm"  class="toggle-password toggle-settings fa fa-eye-slash" (click)=" showPassword('confirmpassword')"></span>
                      <span  *ngIf="isConfirm"  class="fa fa-eye toggle-password toggle-settings" (click)="hidePassword('confirmpassword')"></span>
                  </div>
                </div>


              </div>

              <!-- <div class="row mar-top10">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for="pass" class="nn-lbl-sett">{{'Password' | translate}}:</label>
                    <input type="password" class="form-control nn-input-sett" id="pass" name="password" [(ngModel)]="password"
                      name="pass" value="">


                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for="cpass" class="nn-lbl-sett">{{'Confirm Password' | translate}}:</label>
                    <input type="password" class="form-control nn-input-sett" id="cpass" name="cPassword" [(ngModel)]="cPassword"
                      value="">

                  </div>
                </div>

              </div> -->


              <div *ngIf="loginLoaderShow" class="loader">
                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <g transform="rotate(208.756 50 50)">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
                      keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                    <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                    <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                    <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                  </g>
                </svg>
              </div>

              <div class="btm-btns-div  clearfix float-r-inside" *ngIf="updatePasswordBtn">
                <div class="leftside clearfix">
                  <button class="update-buttons" (click)="updatePassword()">
                    {{'UPDATE' | translate}}
                  </button>
                </div>

              </div>

              <div class='clear'></div>
            </div>

          </div>

          <!-- <div class="update-password ">

            <div class="gnrl-setting-form">

              <h2 class="sub-title no-left-margin">{{'FORGOT PASSWORD' | translate}}

              </h2>

              <p class="color-blue" style="margin-top: 10px; margin-bottom: 20px;">
                {{'Enter your email address and we will send you a password reset link' | translate}}
              </p>

              <div class="row mar-top10">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for="forgotEmail" class="nn-lbl-sett">{{'Email' | translate}}:</label>
                    <input type="email" class="form-control nn-input-sett" id="forgotEmail" name="forgotEmail"
                      [(ngModel)]="forgotEmail" [value]="userObject?.Email" placeholder="{{'Enter your email' | translate}}">
                  </div>
                </div>
              </div>

              <div *ngIf="forgotPasswordLoader" class="loader">
                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <g transform="rotate(208.756 50 50)">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
                      keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                    <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                    <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                    <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                  </g>
                </svg>
              </div>

              <div class="btm-btns-div  clearfix float-r-inside" *ngIf="forgotPasswordBtn">
                <div class="leftside clearfix">
                  <button class="update-buttons" (click)="sendForgotPasswordRequest()">
                    {{'SEND RESET LINK' | translate}}
                  </button>
                </div>

              </div>

              <div class='clear'></div>
            </div>

          </div> -->


          <!-- <div class="acc-conf-div d-none d-lg-block">
            <h2 class="sub-title no-left-margin">{{'ACCOUNT CONFIRMATION' | translate}}
              <span class="sub-title-dash">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                  <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAMAAABkWjdgAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX///8gl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9T///+ffR1AAAAAEHRSTlMA7f3+9O/wYHFOROA1+8ojSqzE/AAAAAFiS0dEAIgFHUgAAAAHdElNRQfiBhsLFicqx9pKAAAAOUlEQVQY02NgBAEmZmyAhRENsLKxMwiQAjgYSFHPwslAinpGLgZS1HPzgJQzYPUvLyu6Vxn5+MHKAb8aC8h9RInbAAAAAElFTkSuQmCC" />
                </svg>
              </span>
            </h2>


            <div class="genrl-sett-content-div">
              <div class="table-responsive" id="confirmation-table">
                <table class="table step-table">
                  <tbody>
                    <tr>
                      <td class="noBordertop width15">
                        <div class="step-images">
                          <img src="../../../assets/img/step1.png">
                        </div>
                      </td>
                      <td class="noBordertop width15 ">
                        <img src="../../../assets/img/email-ver.png">
                      </td>
                      <td class="noBordertop width55 padding-top35">
                        <p class="tbl-col3-txt">
                          {{'E-MAIL VERIFICATION' | translate}}
                        </p>
                      </td>
                      <td class="noBordertop w-25">
                        <div class="verified-btn-wrapper">
                          <button class="table-verified">
                              {{'Verified' | translate}}
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="step-images">
                          <img src="../../../assets/img/step2.png">
                        </div>
                      </td>
                      <td>
                        <img src="../../../assets/img/card-img.png">
                      </td>
                      <td class="padding-top35">
                        <p class="tbl-col3-txt ">
                          KYC
                        </p>
                      </td>
                      <td class="w-25">
                        <div class="verified-btn-wrapper">
                          <button class="table-verified" [ngClass]="userKycStatus">
                            {{AcutalStatus | translate}}
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="custom-bor-btm">
                        <div class="step-images">
                          <img src="../../../assets/img/step3.png">
                        </div>
                      </td>
                      <td class="custom-bor-btm custom-bor-btm">
                        <img src="../../../assets/img/addr-img.png">
                      </td>
                      <td class="padding-top35 custom-bor-btm">
                        <p class="tbl-col3-txt ">
                          ETH {{'Address' | translate}}
                        </p>
                      </td>
                      <td class="custom-bor-btm w-25">
                        <div class="verified-btn-wrapper">
                          <button class="table-verified" *ngIf="userObject.WalletAddress">
                            {{'Submitted' | translate}}
                          </button>
                          <button class="table-verified NOT_SUBMITTED" *ngIf="!userObject.WalletAddress">
                            {{'Not Submitted' | translate}}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div> -->
        </div>
        <!--column second half start-->
        <div class="col-lg-6">
          <div class="authentication-sett-div">
            <h2 class="sub-title no-left-margin">{{'Google Authentication' | translate}}

            </h2>
            <div class="floated-right">
              <ui-switch (change)="enableDisable2FA($event)" class="enable2fa" [disabled]="disableSwitch" [checked]="userObject.twoFAStatus"></ui-switch>
            </div>

            <div class="clear"></div>
            <p class="color-blue">{{'Two-Factor Authentication (2FA) increases the security of your Pip Crypto ILO account. We therefore recommend to activate 2FA.' | translate}}</p>

            <div class="loader" *ngIf="twoFaLoader">
              <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <g transform="rotate(208.756 50 50)">
                  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
                    keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                  <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                  <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                  <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                </g>
              </svg>
            </div>

            <div class="authentication-sett-content-div clearfix transition" [hidden]="!enable2faDiv" [ngClass]="{'transition':enable2faDiv}">
              <div class="leftside left-qr clearfix padding4 phn-width-100 ipad-width-100 breaking-divs centered-ipad centered">
                <!-- <qr-code [value]="ToTpUri" [size]="130" class="qrcodeSize"></qr-code> -->
                <!-- <img src="{{ToTpUri}}" class="qrcodeSize" /> -->

                <img *ngIf="ToTpUri" [src]="ToTpUri" class="qrcodeSize" alt="QR Code for 2FA" (error)="$event.target.style.display='none'" />
              </div>
              <div class="leftside right-detail clearfix width75 ipad-width-100  breaking-divs phn-width-100 ">
                <div class="">
                  <p class="auth-sett-text1">
                    {{'Two - Factor Authentication' | translate}}
                  </p>
                  <p class="auth-sett-text2">
                    {{'Enter code to enable 2FA' | translate}}
                  </p>
                  <div class="auth-sett-seagreen-div">



                    <div class="twoFa-btns clearfix">

                      <div class="left-input clearfix">
                        <input type="text" maxlength="6" (keypress)="isNumberKeyTwoFA($event)" id='twoFaCode' (keydown)="authenticateOnEnter($event)"
                          class="form-control nn-input-sett" placeholder="{{'Authentication code here' | translate}}" name="twoFaCode"
                          [(ngModel)]="twoFaCode">
                      </div>

                      <div class="right-authenticate clearfix">

                        <div class="abs-loader" *ngIf="authenticateApiLoader">
                          <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <g transform="rotate(208.756 50 50)">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
                                keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                              <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                              <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                              <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                            </g>
                          </svg>
                        </div>

                        <button class="seagrean-buttons" *ngIf="authBtn" (click)="authenticate2Fa()">
                          {{'authenticate' | translate}}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- Disabled Div -->



            <div class="authentication-sett-content-div clearfix transition" *ngIf="disable2FA" [ngClass]="{'transition':enable2faDiv}">

              <div class="">
                <div class="">

                  <p class="auth-sett-text2">
                    {{'You have two factor authentication enabled, Enter code to disable 2FA' | translate}}
                  </p>
                  <div class="auth-sett-seagreen-div">



                    <div class="twoFa-btns clearfix">

                      <div class="disable-left clearfix">
                        <input type="text" maxlength="6" (keypress)="isNumberKeyTwoFA($event)" id='twoFaCode' (keydown)="disableOnEnter($event)"
                          class="form-control nn-input-sett" placeholder="Authentication code here .." name="twoFaCode"
                          [(ngModel)]="twoFaCode">
                      </div>

                      <div class="disable-right clearfix">

                        <div class="abs-loader" *ngIf="disable2faLoader">
                          <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <g transform="rotate(208.756 50 50)">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
                                keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                              <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                              <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                              <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                            </g>
                          </svg>
                        </div>

                        <button class="seagrean-buttons" *ngIf="authBtn" (click)="disable2FAFunction()">
                          {{'Disable' | translate}}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Disbaled Div -->



          </div>


          <div class="acc-conf-div d-none d-lg-block">
            <h2 class="sub-title no-left-margin">{{'ACCOUNT CONFIRMATION' | translate}}
              <span class="sub-title-dash">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                  <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAMAAABkWjdgAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX///8gl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9T///+ffR1AAAAAEHRSTlMA7f3+9O/wYHFOROA1+8ojSqzE/AAAAAFiS0dEAIgFHUgAAAAHdElNRQfiBhsLFicqx9pKAAAAOUlEQVQY02NgBAEmZmyAhRENsLKxMwiQAjgYSFHPwslAinpGLgZS1HPzgJQzYPUvLyu6Vxn5+MHKAb8aC8h9RInbAAAAAElFTkSuQmCC" />
                </svg>
              </span>
            </h2>


            <div class="genrl-sett-content-div">
              <div class="table-responsive" id="confirmation-table">
                <table class="table step-table">
                  <tbody>
                    <tr>
                      <td class="noBordertop width15">
                        <div class="step-images">
                          <img src="../../../assets/img/step1.png">
                        </div>
                      </td>
                      <td class="noBordertop width15 ">
                        <img src="../../../assets/img/email-ver.png">
                      </td>
                      <td class="noBordertop width55 padding-top35">
                        <p class="tbl-col3-txt">
                          {{'E-MAIL VERIFICATION' | translate}}
                        </p>
                      </td>
                      <td class="noBordertop w-25">
                        <div class="verified-btn-wrapper">
                          <button class="table-verified">
                              {{'Verified' | translate}}
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="step-images">
                          <img src="../../../assets/img/step2.png">
                        </div>
                      </td>
                      <td>
                        <img src="../../../assets/img/card-img.png">
                      </td>
                      <td class="padding-top35">
                        <p class="tbl-col3-txt ">
                          KYC
                        </p>
                      </td>
                      <td class="w-25">
                        <div class="verified-btn-wrapper">
                          <button class="table-verified" *ngIf="kycInfo?.status == 'SUBMITTED' || kycInfo?.status == 'ACCEPTED'">
                            {{kycInfo?.status}}
                          </button>
                          <button class="table-verified NOT_SUBMITTED" *ngIf="!kycInfo">
                            NOT SUBMITTED
                          </button>
                          <!-- <button class="table-verified" [ngClass]="userKycStatus">
                            {{AcutalStatus | translate}}
                          </button> -->
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="custom-bor-btm">
                        <div class="step-images">
                          <img src="../../../assets/img/step3.png">
                        </div>
                      </td>
                      <td class="custom-bor-btm custom-bor-btm">
                        <img src="../../../assets/img/addr-img.png">
                      </td>
                      <td class="padding-top35 custom-bor-btm">
                        <p class="tbl-col3-txt ">
                          TRON {{'Address' | translate}}
                        </p>
                      </td>
                      <td class="custom-bor-btm w-25">
                        <div class="verified-btn-wrapper">
                          <button class="table-verified" *ngIf="userObject.WalletAddress">
                            {{'Submitted' | translate}}
                          </button>
                          <button class="table-verified NOT_SUBMITTED" *ngIf="!userObject.WalletAddress">
                            {{'Not Submitted' | translate}}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
              
              <div class="identification" *ngIf="isExist">
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex flex-column  ">
                      <div class="m-tb tbl-col3-txt">Country</div>
                      <div class="m-tb tbl-col3-txt">Expiry Date</div>
                      <div class="m-tb tbl-col3-txt">Identification Type</div>
                      <div class="m-tb tbl-col3-txt">Issued Date</div>
                      <div class="m-tb tbl-col3-txt">State</div>
                      <div class="m-tb tbl-col3-txt">Kyc Status</div>

                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="tbl-col3-txt m-tb" *ngFor="let item of kycInfo | keyvalue">
                      {{item.value}}
                 </div>
                  </div>
                </div>
                
              </div>

            </div>
          </div>

          <div class="upload-id-div d-none">

            <h2 class="sub-title no-left-margin">KYC

            </h2>


            <div *ngIf="userKycStatus=='SUBMITTED'">
              <p class="accepted-text">{{'Your KYC is under review' | translate}}</p>
            </div>

            <div *ngIf="userKycStatus=='ACCEPTED'">
              <p class="accepted-text">{{'Your KYC has been accepted by fruture team' | translate}}</p>
            </div>

            <div *ngIf="userKycStatus=='REJECTED'">
              <p class="rejected-text">{{'Your KYC was rejected please resubmit' | translate}}</p>
            </div>

            <!-- <div class="upload-id-content-div clearfix kyc-box" *ngIf="IframeBox">

                            <div class="resp-container">
                                <iframe class="resp-iframe" [src]='kycUrl | safe' allow="encrypted-media;camera;microphone" allowfullscreen></iframe>
                            </div>

                        </div> -->

            <div class="upload-id-content-div clearfix kyc-box" *ngIf="kycBox">

              <div class="pos-left2">
                <label *ngIf="!showDetails" class="nn-lbl-sett" style="margin-bottom:10px !important" for="name">Select
                  {{'Select ID Type' | translate}}:</label>
                <div *ngIf="!showDetails" class="clear"></div>
                <span *ngIf="!showDetails" class="checkp btm-marg">
                  <input type="radio" name="gender" class='settings-checkboxes' id="ine" value="INE" (change)="getIDType($event.target.value)" />
                  <label for="ine">INE</label>
                </span>
                <span *ngIf="!showDetails" class="checkp pad-btm m-l-30">
                  <input type="radio" name="gender" class='settings-checkboxes' id="passport" value="PASSPORT" (change)="getIDType($event.target.value)" />
                  <label for="passport">{{'Passport' | translate}}</label>
                </span>

                <div class="row margin-top">
                  <div class="col-md-4 col-xl-4 col-xs-6">
                    <p class="text-center font-size-14 color-blue">{{img_type | translate}} {{'FRONT' | translate}}</p>
                    <div class="img-box" style="text-align: center">
                      
                     
                      <img  class="img-area" src={{frontPhoto}} (click)="openfrontFileChooser()">
                      
                      <input type="file" style="display:none" id="idFront" (change)=frontImage($event)>
                    </div>
                  </div>
                  <div class="col-md-4 col-xl-4 col-xs-6">
                    <p class="text-center font-size-14 color-blue">{{img_type | translate}} {{'BACK' | translate}}</p>
                    <div class="img-box" style="text-align: center">
                      
                      <img class="img-area" src={{backPhoto}} (click)="openBackFileChooser()">
                      <input type="file" style="display:none" id="idBack" (change)=backImage($event)>
                    </div>
                  </div>
                </div>

                <div *ngIf="!showDetails" class="margin-top">
                  <label *ngIf="!showDetails" class="nn-lbl-sett color-blue" style="margin-bottom:10px !important">{{'Proof of Address' | translate}}</label>
                  <!-- <h6>Proof of Address</h6> -->
                  <p style="margin-bottom: 0px !important" class="color-blue">{{'Please upload either electricity or phone bill to provide proof of address' | translate}}</p>
                </div>

                <label *ngIf="!showDetails" class="nn-lbl-sett" style="margin-bottom:10px !important" for="billtype">Select
                  {{'Select Bill Type' | translate}}:</label>
                <div *ngIf="!showDetails" class="clear"></div>

                <span *ngIf="!showDetails" class="checkp btm-marg">
                  <input type="radio" name="bill" class='settings-checkboxes' id="phone" value="PHONE" (change)="getBillType($event.target.value)" />
                  <label for="phone" class="color-blue">{{'Phone' | translate}}</label>
                </span>
                <span *ngIf="!showDetails" class="checkp pad-btm m-l-30">
                  <input type="radio" name="bill" class='settings-checkboxes' id="electricity" value="ELECTRICITY"
                    (change)="getBillType($event.target.value)" />
                  <label for="electricity" class="color-blue">{{'Electricity' | translate}}</label>
                </span>

                <div class="row margin-top">
                  <div class="col-md-4 col-xl-4 col-xs-6">
                    <p class="text-center font-size-14" class="color-blue">{{billTypeImage | translate}} {{'BILL' | translate}}</p>
                    <div class="img-box" style="text-align: center">
                      <img class="img-area" src={{billPhoto}} (click)="openBillFileChoose()">
                      <input type="file" style="display:none" id="idBill" (change)=billImageEvent($event)>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="form-group">
                                <label class="nn-lbl-sett" for="Country">Select Country:</label>
                                <select class="form-control nn-input-sett" id="country" [(ngModel)]="country" name="country" (change)="getSelectedCountry($event.target.value)">
                                    <option selected disabled value="">Select your country</option>
                                    <option *ngFor="let country of countries" value="{{country.name}}">{{country.name}}</option>
                                </select>
                            </div> -->

              <!-- <div class="form-group">
                                <label class="nn-lbl-sett" for="Country">Select Nationality:</label>
                                <select class="form-control nn-input-sett" id="nationality" [(ngModel)]="countryCode" name="countryCode" (change)="getSelectedNationality($event.target.value)">
                                    <option selected disabled value="">Select your country</option>
                                    <option *ngFor="let country of nationalities" value="{{country.alpha2Code}}">{{country.name}}</option>
                                </select>
                            </div> -->

              <!-- <div class='form-group'>
                                <label class="nn-lbl-sett" for="Country">Date of Birth:</label>
                                <div class="input-group">
                                    <input readonly class="form-control nn-input-sett" placeholder="yyyy-mm-dd" name="dob" [(ngModel)]="dob" ngbDatepicker #d="ngbDatepicker">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                                            <i class="fas fa-calendar-alt"></i>
                                        </button>
                                    </div>
                                </div>

                            </div> -->

              <div class="row">
                <div class="col-4">
                  <div class='form-group'>
                    <label class="nn-lbl-sett" for="ccode">{{'Country Code' | translate}}</label>
                    <input type="tel" maxlength="4" id="ccode" [disabled]="showDetails" (keypress)="isNumberKey($event, true)"
                      name="selectedCode" [(ngModel)]="selectedCode" class="form-control nn-input-sett">
                    <!-- <select name="selectedCode" id="ccode" class="form-control nn-input-sett" [(ngModel)]="selectedCode">
                      <option value="default" selected>Selected Country</option>
                      <option *ngFor="let country of countryCodes" [value]="country.dial_code">{{country.code}}</option>
                    </select> -->
                  </div>
                </div>
                <div class="col-8">
                  <div class='form-group'>
                    <label class="nn-lbl-sett" for="Country">{{'Phone Number' | translate}}</label>
                    <input type="tel" maxlength="10" id="phoneNumber" [disabled]="showDetails" (keypress)="isNumberKey($event, false)"
                      name="phoneNumber" [(ngModel)]="phoneNumber" class="form-control nn-input-sett">
                  </div>
                </div>
              </div>
              




              <div *ngIf="!showDetails">
                <div class="btm-btns-div clearfix float-r-inside" *ngIf="kycBtn">
                  <div class="leftside clearfix">
                    <button class="update-buttons" (click)="submitKyc()">
                        {{'SUBMIT' | translate}}
                    </button>
                  </div>


                </div>
              </div>





            </div>

            <div *ngIf="kycLoader" class="loader">
              <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <g transform="rotate(208.756 50 50)">
                  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;0 50 50"
                    keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline"></animateTransform>
                  <path fill="#85ffbd" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"></path>
                  <path fill="#316598" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"></path>
                  <path fill="#a4bcc2" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"></path>
                </g>
              </svg>
            </div>

          </div>


          <!--  <div class="upload-id-div">
                        <h2 class="sub-title no-left-margin">Upload Id

                        </h2>
                        <div class="upload-id-content-div clearfix">
                            <div class="leftside clearfix phn-width-100 centered ipad-width-100">
                                <img src="../../../assets/img/upload.png" id="blah" class="image-upload-cover">

                            </div>
                            <div class="leftside clearfix phn-width-100 ipad-width-100 centered-ipad">
                                <div class="padding2040 phn-adjustmnt  ">
                                    <p class="upload-file-txt">
                                        Upload file (JPG,GIF,PNG formats)
                                    </p>
                                    <div class="upload-id-content-div clearfix ">
                                        <div class="leftside clearfix phn-width-100 ipad-width-100">
                                            <div class="hexa-back">

                                                <button class="choose-buttons" (click)="changeImage()">

                                                    <input type='file' (change)="changeimage($event)" id="imgInp" style="visibility:hidden;width:0;height:0" /> Choose file
                                                </button>
                                            </div>
                                        </div>
                                        <div class="leftside clearfix phn-width-100 ipad-width-100">
                                            <p class="nofileChoosn-txt">
                                                no file chosen
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
 -->
          <!--  <div class="add-proof-div">
                        <h2 class="sub-title no-left-margin">Address Proof
                            <span class="sub-title-dash">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                                    <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAMAAABkWjdgAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX///8gl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9T///+ffR1AAAAAEHRSTlMA7f3+9O/wYHFOROA1+8ojSqzE/AAAAAFiS0dEAIgFHUgAAAAHdElNRQfiBhsLFicqx9pKAAAAOUlEQVQY02NgBAEmZmyAhRENsLKxMwiQAjgYSFHPwslAinpGLgZS1HPzgJQzYPUvLyu6Vxn5+MHKAb8aC8h9RInbAAAAAElFTkSuQmCC"
                                    />
                                </svg>
                            </span>
                        </h2>
                        <div class="upload-id-content-div clearfix">
                            <div class="leftside clearfix width18  phn-width-100 centered ipad-width-100">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="93px" height="133px">
                                    <image x="0px" y="0px" width="93px" height="133px" xlink:href="data:img/png;base64,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"
                                    />
                                </svg>
                            </div>
                            <div class="leftside width82 clearfix phn-width-100 ipad-width-100 ">
                                <div class="paddingleft-30 noPaddingLeft">
                                    <div class="row">
                                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <div class="form-group ">
                                                <label class="nn-lbl-sett" for="add1">Address line 1:</label>
                                                <input class="form-control nn-input-sett" id="add1" name="add1" type="text" value="Malibu Beach">
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                            <div class="form-group ">
                                                <label class="nn-lbl-sett" for="add2">Address line 2:</label>
                                                <input class="form-control nn-input-sett" id="add2" name="add2" type="email" value="">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="btm-btns-div clearfix float-r-inside">
                                        <div class="leftside clearfix">
                                            <button class="proof-buttons">
                                                proof of address
                                            </button>
                                        </div>
                                        <div class="leftside clearfix m-left-25">
                                            <button class="cancel-buttons">
                                                cancel
                                            </button>
                                        </div> 

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div> -->




          <div class="acc-conf-div d-block d-lg-none">
            <h2 class="sub-title no-left-margin">{{'ACCOUNT CONFIRMATION' | translate}}
              <span class="sub-title-dash">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                  <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAMAAABkWjdgAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX///8gl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9Qgl9T///+ffR1AAAAAEHRSTlMA7f3+9O/wYHFOROA1+8ojSqzE/AAAAAFiS0dEAIgFHUgAAAAHdElNRQfiBhsLFicqx9pKAAAAOUlEQVQY02NgBAEmZmyAhRENsLKxMwiQAjgYSFHPwslAinpGLgZS1HPzgJQzYPUvLyu6Vxn5+MHKAb8aC8h9RInbAAAAAElFTkSuQmCC" />
                </svg>
              </span>
            </h2>
            <div class="genrl-sett-content-div">
              <div class="table-responsive" id="confirmation-table">
                <table class="table ">
                  <tbody>
                    <tr>
                      <td class="noBordertop width15">
                        <div>
                          <img src="../../../assets/img/step1.png">
                        </div>
                      </td>
                      <td class="noBordertop width15 ">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="80px"
                          height="74px">
                          <image x="0px" y="0px" width="70px" height="60px" xlink:href="data:img/png;base64,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" />
                        </svg>
                      </td>
                      <td class="noBordertop width55 padding-top35 hiding-on-fone">
                        <p class="tbl-col3-txt">
                          {{'E-MAIL VERIFICATION' | translate}}
                        </p>
                      </td>
                      <td class="noBordertop width15 padding-top25">
                        <div class="btm-btns-div clearfix">

                          <div class="leftside clearfix">
                            <p class="tbl-col3-txt hiding-on-large">
                                {{'E-MAIL VERIFICATION' | translate}}
                            </p>

                            <div class="verified-btn-wrapper">
                              <button class="table-verified">
                                  {{'Verified' | translate}}
                              </button>
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <img src="../../../assets/img/step2.png">
                        </div>
                      </td>
                      <td>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="89px"
                          height="73px">
                          <image x="0px" y="0px" width="70px" height="60px" xlink:href="data:img/png;base64,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" />
                        </svg>
                      </td>
                      <td class="padding-top35 hiding-on-fone">
                        <p class="tbl-col3-txt ">
                          KYC
                        </p>
                      </td>
                      <td class="padding-top25">
                        <div class="btm-btns-div clearfix">

                          <div class="leftside clearfix">
                            <p class="tbl-col3-txt hiding-on-large">
                              KYC
                            </p>
                            <div class="verified-btn-wrapper">
                              <button class="table-verified" [ngClass]='userKycStatus'>
                                {{AcutalStatus | translate}}
                              </button>
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="custom-bor-btm">
                        <div>
                          <img src="../../../assets/img/step3.png">
                        </div>
                      </td>
                      <td class="custom-bor-btm custom-bor-btm">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56px"
                          height="80px">
                          <image x="0px" y="0px" width="70px" height="60px" xlink:href="data:img/png;base64,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" />
                        </svg>
                      </td>
                      <td class="padding-top35 custom-bor-btm hiding-on-fone">

                        <p class="tbl-col3-txt ">
                          TRON {{'Address' | translate}}
                        </p>

                      </td>
                      <td class="padding-top25 custom-bor-btm">
                        <div class="btm-btns-div clearfix">

                          <div class="leftside clearfix">
                            <p class="tbl-col3-txt hiding-on-large">
                              TRON {{'Address' | translate}}
                            </p>
                            <div class="verified-btn-wrapper">
                              <button class="table-verified" *ngIf="userObject.WalletAddress">
                                {{'Submitted' | translate}}
                              </button>
                              <button class="table-verified NOT_SUBMITTED" *ngIf="!userObject.WalletAddress">
                                {{'Not Submitted' | translate}}
                              </button>
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <div class="identification" *ngIf="isExist">
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex flex-column  ">
                      <div class="m-tb tbl-col3-txt">Country</div>
                      <div class="m-tb tbl-col3-txt">Expiry Date</div>
                      <div class="m-tb tbl-col3-txt">Identification Type</div>
                      <div class="m-tb tbl-col3-txt">Issued Date</div>
                      <div class="m-tb tbl-col3-txt">State</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="tbl-col3-txt m-tb" *ngFor="let item of kycInfo | keyvalue">
                      {{item.value}}
                  </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

        </div>


      </div>

    </div>
  </div>
</section>